import {
  Box,
  Checkbox,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@emotion/react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Dropdown from "../../reusable_components/components/Dropdown";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import dayjs from "dayjs";
import MUIButton from "../../reusable_components/components/MUIButton";
import Loader from "../../reusable_components/components/Loader";
import { useAddRecruiterSignUpMutation } from "../../redux/Recruiters/Recruiters.api";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { useGetWorkCategoryDropDownQuery } from "../../redux/Signup/signup.api";
import { useGetPositionLevelDropDownQuery } from "../../redux/Signup/signup.api";
const AddRecruiter = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();
  const { value } = location.state || "";
  const { Snackbar } = useContext(SnackbarContext);
  const [showOverAllLoader, setShowOverAllLoader] = useState(false);
  const [addRecruiter] = useAddRecruiterSignUpMutation();
  const { data: getWorkCategoryDropDown } = useGetWorkCategoryDropDownQuery();
  const { data: getPositionLevelDropDown } = useGetPositionLevelDropDownQuery();
  const [selectedKeywordIds, setSelectedKeywordIds] = useState([1, 2]);
  const [selectedlevelIds, setSelectedlevelIds] = useState([1, 2, 3, 4]);
  const isSmallcreen = useMediaQuery(theme.breakpoints.down("md"));

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("First Name is required")
      .matches(/^[A-Za-z\s]+$/, "must only contain letters"),
    email: Yup.string()
      .email("Enter Valid Email")
      .required("Please Enter the email")
      .test("Enter Valid Email", "Enter Valid Email", (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
      }),
    companyName: Yup.string()
      .notRequired()
      .test("is-letters-only", "must only contain letters", (value) => {
        if (!value) return true; // allow empty (not required)
        return /^[A-Za-z0-9\s]+$/.test(value);
      }),
    contactNumber: Yup.string().required("Contact Number  is Required"),
    // .min(10, "Alternate number must be exactly 10 digits")
    // .max(10, "Alternate number must be exactly 10 digits"),
    gender: Yup.string().required("Gender is Required"),
    address: Yup.string().required("Address is Required"),
    dateOfBirth: Yup.date()
      .nullable()
      .required("Date of Birth is Required")
      .max(new Date(), "Date of Birth cannot be in the future"),
    city: Yup.string().required("City is Required"),
    state: Yup.string().required("State is Required"),
    pincode: Yup.string().required("Pincode is Required"),
    alternateEmail: Yup.string()
      .notRequired()
      .test(
        "valid-and-different-email",
        "Enter a valid alternate email and it must be different from primary email",
        function (value) {
          const email = this.resolve(Yup.ref("email"));
          if (!value) return true; // allow empty
          const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          return isValidEmail && value !== email;
        }
      ),

    alternateNumber: Yup.string()
      .notRequired()
      .test(
        "valid-and-different-number",
        "Alternate number must be different from contact number",
        function (value) {
          const contactNumber = this.resolve(Yup.ref("contactNumber"));
          if (!value) return true; // allow empty
          return value !== contactNumber;
        }
      ),
    category: Yup.array()
      .min(1, "Select at least one category")
      .required("Category is required"),
    level: Yup.array()
      .min(1, "Select at least one level")
      .required("Level is required"),
  });

  const resolver = yupResolver(validationSchema);

  const {
    control,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({
    resolver,
    mode: "onChange",
    defaultValues: {
      name: "",
      address: "",
      city: "",
      email: "",
      state: "",
      pincode: "",
      contactNumber: "",
      gender: "",
      dateOfBirth: null,
      alternateEmail: "",
      alternateNumber: "",
      companyName: "",
      category: [1, 2],
      level: [1, 2, 3, 4]

    },
  });

  const handleNavigateBack = () => {
    navigate(-1);
  };

  const onSubmit = async (data) => {
    try {
      const payload = {
        address: data?.address,
        alternateEmail: data?.alternateEmail || "",
        alternatePhone: data?.alternateNumber || "",
        city: data?.city,
        companyName: data?.companyName || "",
        contactNumber: data?.contactNumber,
        email: data?.email,
        name: data?.name,
        pincode: data?.pincode,
        state: data?.state,
        gender: data?.gender,
        dob: data?.dateOfBirth
          ? dayjs(data?.dateOfBirth).format("DD-MM-YYYY")
          : null,
        isExternalRecruiter: value === "1" ? "Y" : "N",
        workCategoryIds: selectedKeywordIds || [],
        jobPositionLevels: selectedlevelIds || [],
      };
      setShowOverAllLoader(true);
      const response = await addRecruiter(payload).unwrap();
      setShowOverAllLoader(false);
      if (response?.status === 200) {
        if (value === "0") {
          Snackbar("Internal Recruiter Added Successfully", "success");
          setShowOverAllLoader(false);
          navigate("/recruiter-list");
        } else {
          Snackbar("Business Associate Added Successfully", "success");
          setShowOverAllLoader(false);
          navigate("/recruiter-list");
        }
      } else if (response?.status === "error") {
        Snackbar(response?.data?.error_message, "error");
        setShowOverAllLoader(false);
      }
    } catch (error) {
      Snackbar("Network error", "error");
      setShowOverAllLoader(false);
    }
  };
  const genderOptions = [
    {
      id: "Male",
      label: "Male",
    },
    {
      id: "Female",
      label: "Female",
    },
    {
      id: "Transgender",
      label: "Transgender",
    },
  ];

  const category = [
    {
      id: 1,
      label: "IT",
    },
    {
      id: 2,
      label: "Non IT",
    },
  ];

  return (
    <Box className="container">
      {showOverAllLoader ? <Loader /> : ""}
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
          marginBottom: "20px",
        }}
        onClick={handleNavigateBack}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>
      <Typography className="title" sx={{ marginLeft: "10%" }}>
        {value === "0" ? "Add Internal Recruiter" : "Add Business Associate"}
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid2
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box className="formBox">
            <Grid2
              item
              container
              sx={{
                display: !isSmallcreen ? "flex" : "",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels">
                    Name <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"name"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter name"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={errors?.name ? errors?.name?.message : ""}
                      />
                    )}
                  />
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {errors?.firstName ? errors?.firstName?.message : ""}
                  </span>
                </Box>

                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Email <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"email"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter email"
                        onChange={(e) => {
                          field.onChange(e);
                          trigger("alternateEmail");
                        }}
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={errors?.email ? errors?.email?.message : ""}
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Company Name
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"companyName"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter company name"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={
                          errors?.companyName
                            ? errors?.companyName?.message
                            : ""
                        }
                      // onChange={handleCompanyNameChange}
                      />
                    )}
                  />
                </Box>
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Contact Number <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"contactNumber"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter contact number"
                        onChange={(e) => {
                          field.onChange(e); // update field value
                          trigger("alternateNumber"); // manually trigger validation of alternate number
                        }}
                        type="number"
                        inputProps={{
                          maxLength: 10,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        sx={{
                          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={
                          errors?.contactNumber
                            ? errors?.contactNumber?.message
                            : ""
                        }
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Address <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <div style={{ width: "100%" }}>
                    <Controller
                      control={control}
                      name={"address"}
                      render={({ field }) => (
                        <textarea
                          {...field}
                          className="jobPostingTextAreas"
                          placeholder="Enter address"
                          style={{ width: "100%", resize: "none" }}
                        />
                      )}
                    />
                    {errors?.address && (
                      <div style={{ color: "red", fontSize: "0.8rem" }}>
                        {errors?.address?.message}
                      </div>
                    )}
                  </div>
                </Box>
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Gender <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Controller
                      control={control}
                      name="gender"
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          className="dropdown"
                          displayEmpty
                          placeholder="Select gender"
                          valueKey="id"
                          labelKey="label"
                          options={genderOptions}
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: "red",
                              marginLeft: "-1px",
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.gender?.message && (
                      <span style={{ color: "red", fontSize: "0.8rem" }}>
                        {errors?.gender?.message}
                      </span>
                    )}
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Date of Birth <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    name="dateOfBirth"
                    control={control}
                    render={({ field }) => (
                      <MuiDatePicker
                        {...field}
                        value={field.value ? dayjs(field.value) : null}
                        onChange={(date) => field.onChange(date)}
                        maxDate={dayjs().subtract(18, "year")}
                        slotProps={{
                          textField: {
                            error: !!errors.dateOfBirth,
                            helperText: errors.dateOfBirth?.message,
                            FormHelperTextProps: {
                              sx: { color: "red !important" },
                            },
                          },
                        }}
                      />
                    )}
                  />
                </Box>
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    City <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"city"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter city"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={errors?.city ? errors?.city?.message : ""}
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    State <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"state"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter state"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={errors?.state ? errors?.state?.message : ""}
                      />
                    )}
                  />
                </Box>
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Pincode <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"pincode"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="text"
                        className="textfields"
                        placeholder="Enter pincode"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={
                          errors?.pincode ? errors?.pincode?.message : ""
                        }
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Alternate Number
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"alternateNumber"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        type="number"
                        placeholder="Enter alternate number"
                        inputProps={{
                          maxLength: 6,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        sx={{
                          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={
                          errors?.alternateNumber
                            ? errors?.alternateNumber?.message
                            : ""
                        }
                      />
                    )}
                  />
                </Box>
                <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Alternate Email
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"alternateEmail"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter alternate email"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: "red",
                            marginLeft: "-1px",
                          },
                        }}
                        helperText={
                          errors?.alternateEmail
                            ? errors?.alternateEmail?.message
                            : ""
                        }
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: !isSmallcreen ? "row" : "column",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
                rowGap={2}
              >
                <Grid2
                  item
                  sx={{
                    width: !isSmallcreen ? "40%" : "100%",
                  }}
                >
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Work Category <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Controller
                      control={control}
                      name="category"
                      render={({ field }) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap", // allow wrapping
                            gap: 2,
                          }}
                        >
                          {getWorkCategoryDropDown?.response?.map((option) => (
                            <Box
                              key={option.workCategoryId}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                width: "40%", // 2 per row
                              }}
                            >
                              <Checkbox
                                checked={field.value?.includes(
                                  option.workCategoryId
                                )}
                                onChange={(e) => {
                                  let newValue;
                                  if (e.target.checked) {
                                    newValue = [
                                      ...(field.value || []),
                                      option.workCategoryId,
                                    ];
                                  } else {
                                    newValue = field.value.filter(
                                      (id) => id !== option.workCategoryId
                                    );
                                  }

                                  field.onChange(newValue);
                                  setSelectedKeywordIds(newValue);
                                }}
                              />
                              {option.workCategoryName}
                            </Box>
                          ))}
                        </Box>
                      )}
                    />
                    {errors?.category?.message && (
                      <span style={{ color: "red", fontSize: "0.8rem" }}>
                        {errors?.category?.message}
                      </span>
                    )}
                  </Box>
                </Grid2>

                <Grid2
                  item
                  sx={{
                    width: !isSmallcreen ? "40%" : "100%",
                  }}
                >
                  <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                    Position Levels <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Controller
                      control={control}
                      name="level"
                      render={({ field }) => (
                        <FormControl fullWidth>
                          <Select
                            multiple
                            {...field}
                            value={field.value || []} // ensure empty array as default
                            onChange={(e) => (field.onChange(e.target.value), setSelectedlevelIds(e.target.value))} // update react-hook-form
                            displayEmpty
                            renderValue={(selected) =>
                              selected?.length === 0 ? (
                                <span
                                  style={{ color: "#a2a2a2", fontSize: "14px" }}
                                >
                                  Select Levels
                                </span>
                              ) : (
                                selected
                                  .map(
                                    (id) =>
                                      getPositionLevelDropDown?.response.find(
                                        (level) => level.jobPositionLevelId === id
                                      )?.jobPositionLevelName
                                  )
                                  .join(", ")
                              )
                            }
                            sx={{
                              height: "35px",
                              fontSize: "14px",
                              borderRadius: "10px",
                            }}
                          >
                            {getPositionLevelDropDown?.response.map((option) => (
                              <MenuItem
                                key={option.jobPositionLevelId}
                                value={option.jobPositionLevelId}
                                sx={{
                                  margin: "5px",
                                  borderRadius: "7px",
                                  fontSize: "14px",
                                }}
                              >
                                <Checkbox
                                  checked={selectedlevelIds?.includes(
                                    option.jobPositionLevelId
                                  )}
                                  onChange={(e) => {
                                    let newValue;
                                    if (e.target.checked) {
                                      newValue = [
                                        ...(field.value || []),
                                        option.jobPositionLevelId,
                                      ];
                                    } else {
                                      newValue = field.value.filter(
                                        (id) => id !== option.jobPositionLevelId
                                      );
                                    }
                                    field.onChange(newValue);
                                    setSelectedlevelIds(newValue);
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 18 },
                                    padding: 0.2,
                                  }}
                                />
                                {option.jobPositionLevelName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    />
                    {errors?.level?.message && (
                      <span style={{ color: "red", fontSize: "0.8rem" }}>
                        {errors?.level?.message}
                      </span>
                    )}
                  </Box>
                </Grid2>
              </Box>
              <Box
                sx={{
                  marginTop: "2%",
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <MUIButton title="Submit" type="submit" />
              </Box>
            </Grid2>
          </Box>
        </Grid2>
      </form>
    </Box>
  );
};

export default AddRecruiter;
